import axios, { AxiosRequestConfig, AxiosRequestHeaders } from 'axios';

export const baseUrl = 'https://ca-back.we-deliver.net';
//export const baseUrl = 'http://localhost:3009';
interface LoginDto {
  email: string;
  password: string;
}
interface SingUp {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
}
function handelError(error: any) {
  return { status: error?.response?.status, data: error?.response?.data };
}
function handleSuccess(response: any) {
  const data = !!response.data ? response.data : response.data;
  const responseData = isJson(data) ? JSON.parse(data) : data;
  return { status: response.status, data: responseData };
}
const isJson = (str: any) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};
export async function login(user: LoginDto) {
  console.log('read', user);
  const options: AxiosRequestConfig = {
    method: 'POST',
    url: `${baseUrl}/user/signin`,
    data: user,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handelError(error));
}

export async function uploadInventory(
  file: any,
  selColumns: any,
  vendorId: any
) {
  const token = await localStorage.getItem('accessToken');
  const formData = new FormData();
  formData.append('file', file);
  formData.append('vendorId', vendorId);
  formData.append('selColumns[SKU]', selColumns?.SKU);
  formData.append('selColumns[Quantity]', selColumns?.Quantity);
  return axios({
    method: 'post',
    url: `${baseUrl}/inventory/upload`,
    data: formData,

    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => handleSuccess(response))
    .catch((error) => handelError(error));
}
export async function whoAmI() {
  const token = await localStorage.getItem('accessToken');
  const options: AxiosRequestConfig = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/user/whoami`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handelError(error));
}
export async function getVendors(retailerId: any) {
  const token = await localStorage.getItem('accessToken');
  const options: AxiosRequestConfig = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/inventory/vendors?retailerId=${retailerId}`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handelError(error));
}
export async function getRetailers() {
  const token = await localStorage.getItem('accessToken');
  const options: AxiosRequestConfig = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/inventory/retailers`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handelError(error));
}
export async function getVendorInventory(
  vendorId: any,
  limit: any,
  offset: any
) {
  const token = await localStorage.getItem('accessToken');
  const options: AxiosRequestConfig = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/inventory/vendor?vendorId=${vendorId}&limit=${limit}&offset=${offset}`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handelError(error));
}
export async function getInventoryStatus() {
  const token = await localStorage.getItem('accessToken');
  const options: AxiosRequestConfig = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/inventory/stats`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handelError(error));
}
export async function getVendorSettings() {
  const token = await localStorage.getItem('accessToken');
  const options: AxiosRequestConfig = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/inventory/settings`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handelError(error));
}
export async function changeVendorRetailerState(
  vendorId: any,
  retailerId: any
) {
  const token = await localStorage.getItem('accessToken');
  const options: AxiosRequestConfig = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: { vendorId, retailerId },
    url: `${baseUrl}/inventory/settings`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handelError(error));
}
export async function propagateInventory(
  vendorId: any,
  supplierId: any,
  name: any
) {
  const token = await localStorage.getItem('accessToken');
  const options: AxiosRequestConfig = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: { vendorId, supplierId, name },
    url: `${baseUrl}/inventory/propagate`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handelError(error));
}

export async function downloadInventory(vendorId: any, supplierId: any) {
  const token = await localStorage.getItem('accessToken');
  const options: AxiosRequestConfig = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/inventory/download?vendorId=${vendorId}&supplierId=${supplierId}`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handelError(error));
}
export async function getDefaultRole() {
  const token = await localStorage.getItem('accessToken');
  const options: AxiosRequestConfig = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/settings/defaultRole`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handelError(error));
}
export async function getAllRoles() {
  const token = await localStorage.getItem('accessToken');
  const options: AxiosRequestConfig = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/settings/roles`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handelError(error));
}
export async function updateUserRole(id: string, roleId: string) {
  const token = await localStorage.getItem('accessToken');
  const options: AxiosRequestConfig = {
    method: 'POST',
    url: `${baseUrl}/settings/user/role/`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: { id, roleId },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handelError(error));
}
export async function updateSettings(id: string, value: string) {
  const token = await localStorage.getItem('accessToken');
  const options: AxiosRequestConfig = {
    method: 'POST',
    url: `${baseUrl}/settings/update/${id}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: { value },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handelError(error));
}
export async function getAllUsers() {
  const token = await localStorage.getItem('accessToken');
  const options: AxiosRequestConfig = {
    method: 'GET',
    url: `${baseUrl}/settings/users`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handelError(error));
}
export async function getSettingsTypeof(type: string) {
  const token = await localStorage.getItem('accessToken');
  const options: AxiosRequestConfig = {
    method: 'GET',
    url: `${baseUrl}/settings/typeof/${type}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handelError(error));
}
export async function getSettingByName(name: string) {
  const token = await localStorage.getItem('accessToken');
  const options: AxiosRequestConfig = {
    method: 'GET',
    url: `${baseUrl}/settings/name/${name}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handelError(error));
}
export async function getAllRolesWithFeatures() {
  const token = await localStorage.getItem('accessToken');
  const options: AxiosRequestConfig = {
    method: 'GET',
    url: `${baseUrl}/settings/roles/feature`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handelError(error));
}
export async function getAllFeatures() {
  const token = await localStorage.getItem('accessToken');
  const options: AxiosRequestConfig = {
    method: 'GET',
    url: `${baseUrl}/settings/features/all`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handelError(error));
}
export async function deleteRole(id: string) {
  const token = await localStorage.getItem('accessToken');
  const options: AxiosRequestConfig = {
    method: 'DELETE',
    url: `${baseUrl}/settings/user/${id}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handelError(error));
}
export async function deleteUser(id: string) {
  const token = await localStorage.getItem('accessToken');
  const options: AxiosRequestConfig = {
    method: 'DELETE',
    url: `${baseUrl}/settings/user/${id}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handelError(error));
}
